import { gql, TypedDocumentNode } from '@apollo/client'

type GetWorkspacesByIDData = { getWorkspacesByID: any[] }
type GetWorkspacesByIDVars = { ids: (string | undefined)[] }

export const GET_WORKSPACES_BY_ID: TypedDocumentNode<
  GetWorkspacesByIDData,
  GetWorkspacesByIDVars
> = gql`
  query getWorkspaceInfoForTabs($ids: [String]!) {
    getWorkspacesByID(ids: $ids) {
      description
      id
      workspaceType {
        code
        description
      }
      teams {
        id
      }
    }
  }
`
